export default __webpack_public_path__ + "static/media/mentor-default.a0a2a89a.jpg";